var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { Input, Select, Button, Icon } from 'antd';
import { find, clone, isEqual, map, concat } from 'lodash';

var UserTags = function (_super) {
  __extends(UserTags, _super);

  function UserTags() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  UserTags.prototype.onTagChange = function (id, index) {
    var _a = this.props,
        name = _a.name,
        value = _a.value,
        options = _a.options,
        onChange = _a.onChange;
    var option = find(options, {
      id: id
    });
    var operator = option.operators[0] || {};
    var item = {
      tagId: option.id,
      operatorId: operator.id,
      value: ''
    };

    if (option.type === 1) {
      item.value = (option.values[0] || {}).id;
    }

    if (value && value.length) {
      value = concat([], value);
    } else {
      value = [{}];
    }

    value.splice(index, 1, item);

    if (onChange) {
      onChange(value, name);
    }
  };

  UserTags.prototype.onTagOperatorChange = function (id, index) {
    var _a = this.props,
        name = _a.name,
        value = _a.value,
        onChange = _a.onChange;

    if (value !== null) {
      var item = clone(value[index]);
      item.operatorId = id;
      value = concat([], value);
      value.splice(index, 1, item);
    }

    if (onChange) {
      onChange(value, name);
    }
  };

  UserTags.prototype.onTagValueChange = function (event, index) {
    var _a = this.props,
        name = _a.name,
        value = _a.value,
        onChange = _a.onChange;

    if (value !== null) {
      var item = clone(value[index]);
      item.value = event.target.value;
      value = concat([], value);
      value.splice(index, 1, item);
    }

    if (onChange) {
      onChange(value, name);
    }
  };

  UserTags.prototype.onTagValueSelectionChange = function (id, index) {
    var _a = this.props,
        name = _a.name,
        value = _a.value,
        onChange = _a.onChange;

    if (value !== null) {
      var item = clone(value[index]);
      item.value = id;
      value = concat([], value);
      value.splice(index, 1, item);
    }

    if (onChange) {
      onChange(value, name);
    }
  };

  UserTags.prototype.onAddTag = function (index) {
    var _a = this.props,
        name = _a.name,
        value = _a.value,
        onChange = _a.onChange;

    if (value !== null) {
      value = concat([], value);
      value.splice(index + 1, 0, {});
    }

    if (onChange) {
      onChange(value, name);
    }
  };

  UserTags.prototype.onRemoveTag = function (index) {
    var _a = this.props,
        name = _a.name,
        value = _a.value,
        onChange = _a.onChange;

    if (value !== null) {
      value = concat([], value);
      value.splice(index, 1);

      if (!value.length) {
        value = null;
      }
    }

    if (onChange) {
      onChange(value, name);
    }
  };

  UserTags.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  UserTags.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        value = _a.value,
        options = _a.options;
    return options && options.length ? React.createElement("div", {
      className: "user-tags"
    }, map(value, function (tag, index) {
      return _this.renderTag(tag, index);
    }), value && value.length ? null : this.renderTag({}, 0)) : null;
  };

  UserTags.prototype.renderTag = function (tag, index) {
    var _this = this;

    var _a = this.props,
        value = _a.value,
        options = _a.options;
    var option = find(options, {
      id: tag.tagId
    });
    return React.createElement("div", {
      className: "tag",
      key: index
    }, React.createElement(Select, {
      className: "tag-selection",
      placeholder: "\u8BF7\u9009\u62E9",
      value: tag.tagId,
      onChange: function onChange(id) {
        return _this.onTagChange(id, index);
      }
    }, map(options, function (_a) {
      var id = _a.id,
          name = _a.name;
      return React.createElement(Select.Option, {
        key: id
      }, name);
    })), React.createElement(Select, {
      className: "operator-selection",
      value: tag.operatorId,
      disabled: !tag.tagId,
      onChange: function onChange(id) {
        return _this.onTagOperatorChange(id, index);
      }
    }, option && map(option.operators, function (_a) {
      var id = _a.id,
          name = _a.name;
      return React.createElement(Select.Option, {
        key: id
      }, name);
    })), option && option.type === 0 ? React.createElement("div", {
      className: "value-input"
    }, React.createElement(Input, {
      value: tag.value,
      disabled: !tag.tagId,
      onChange: function onChange(e) {
        return _this.onTagValueChange(e, index);
      }
    })) : React.createElement(Select, {
      className: "value-selection",
      value: tag.value,
      disabled: !tag.tagId,
      onChange: function onChange(id) {
        return _this.onTagValueSelectionChange(id, index);
      }
    }, option && map(option.values, function (_a) {
      var id = _a.id,
          name = _a.name;
      return React.createElement(Select.Option, {
        key: id
      }, name);
    })), React.createElement(Button, {
      type: "primary",
      size: "small",
      className: "remove-tag-button",
      disabled: !tag.tagId,
      onClick: function onClick() {
        return _this.onRemoveTag(index);
      }
    }, React.createElement(Icon, {
      type: "minus"
    })), React.createElement(Button, {
      type: "primary",
      size: "small",
      className: "add-tag-button",
      disabled: !tag.tagId || !tag.value,
      style: !value || !value.length || index === value.length - 1 ? undefined : {
        visibility: 'hidden'
      },
      onClick: function onClick() {
        return _this.onAddTag(index);
      }
    }, React.createElement(Icon, {
      type: "plus"
    })));
  };

  return UserTags;
}(Component);

export { UserTags };